/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @next/next/no-img-element */
import { Container } from '@pwskills/rachnaui';
import { useEffect, useRef, useState } from 'react';
import useScreenWidth from '@/hooks/useScreenWidth';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import { useRouter } from 'next/router';
import MasterclassHeader from '../MasterclassHeader';
import GlimpsesAnimFromDesktopAndTab from './desktopTabAnimation';
import MobileAnim from './mobileAnimation';

const GlimpsesSection = ({ showArrow = false }: { showArrow?: boolean }) => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );

  const { glimpseOfMasterClass } = masterclassDetails;

  const screenWidth = useScreenWidth();
  const [isMobile, setIsMobile] = useState(false);
  const glimpsesContainerRef = useRef<HTMLDivElement | null>(null);
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');

  useEffect(() => {
    if (screenWidth && screenWidth < 640) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [screenWidth]);
  return (
    <section className="relative">
      <Container
        id="category-hero-section"
        className={`${
          isDashboard
            ? 'medium:!pt-9 medium:!pb-6 px-4 large:!px-8 pt-9 '
            : 'relative !py-8 medium:!py-8 large:!pt-14 large:!pb-[72px] flex flex-col !px-4 medium:!px-8 large:!px-20 '
        }`}
      >
        <div className="flex flex-col gap-14" ref={glimpsesContainerRef}>
          <div>
            <MasterclassHeader
              headerText="Glimpse of the masterclass"
              className={isDashboard ? 'text-left text-gray-850' : 'text-center'}
            />
          </div>

          {isMobile ? (
            <MobileAnim
              Glimpses={glimpseOfMasterClass}
              glimpsesContainerRef={glimpsesContainerRef}
            />
          ) : (
            <GlimpsesAnimFromDesktopAndTab Glimpses={glimpseOfMasterClass} />
          )}
        </div>
      </Container>

      {showArrow && (
        <img
          src="/images/masterclassDescription/glimpses/arrow.svg"
          alt="arrow"
          style={{
            top: '70px',
          }}
          className="absolute right-0 !top-[70px] medium:w-[130px] large:w-auto  hidden medium:!block"
        />
      )}
      <img
        src="/images/masterclassDescription/glimpses/GlimpsesBg.svg"
        alt="bg"
        className="absolute bottom-0 hidden medium:!block"
      />
    </section>
  );
};

export default GlimpsesSection;
